/* global axios */
import ApiClient from './ApiClient';

class AddOnAPI extends ApiClient {
  constructor() {
    super('add_ons', { accountScoped: true });
  }

  get({ productId } = {}) {
    const query = productId ? `?product_id=${productId}` : '';
    return axios.get(`${this.url}${query}`);
  }
}

export default new AddOnAPI();
